import axios, { AxiosPromise } from 'axios';
import { IContactUs } from '../../../@types/model/home/contactUs';
import { IInfoBoardData } from '../../../@types/model/home/infoBoardData';

export default class HomeHttpService {
    public static getInfoBoardData() : AxiosPromise<Array<IInfoBoardData>> {
        return axios.get(`${API_URL}/v1/Home/InfoBoardData`);
    }

    public static addOrUpdateInfoBoardData(data : IInfoBoardData) : AxiosPromise<IInfoBoardData> {
        return axios.post(`${API_URL}/v1/Home/InfoBoardData/PostInfoBoardData`, data);
    }

    public static getContactUsData() : AxiosPromise<Array<IContactUs>> {
        return axios.get(`${API_URL}/v1/Home/ContactUsData`);
    }

    public static addOrUpdateContactUsData(data : IContactUs) : AxiosPromise<IContactUs> {
        return axios.post(`${API_URL}/v1/Home/ContactUsData/PostContactUsData`, data);
    }
}
